<template>
  <!--  <div class="bottom">-->
  <!--    <div class="bottom-footer">-->
  <!--      <div class="bottom-footer-text">-->
  <!--        <div>Copyright © 2019 灵动创享 All Rights Reserved</div>-->
  <!--        <div>京ICP备19035110号-1</div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->


  <div class="footer">
    <div class="footer-content">
      <!--<div class="footer-logo">-->
      <!--  <img src="" alt="授权：郑州大学">-->
      <!--  <p>虚拟仿真实验教学课程共享平台</p>-->
      <!--</div>-->
      <!--<div class="footer-qr">-->
      <!--  <img src="" alt="QR Code" class="qr-code">-->
      <!--</div>-->
      <div class="footer-info">
        <p v-if="personalizationData.schoolName">
          主办单位：{{ personalizationData.schoolName }}
        </p>
        <p v-if="hasValidFooterInfo">
          <template v-if="personalizationData.icpRecord">
            {{ personalizationData.icpRecord }}
          </template>
          <template v-if="personalizationData.icpRecord && personalizationData.publicSecurity">
            |
          </template>
          <template v-if="personalizationData.publicSecurity">
            {{ personalizationData.publicSecurity }}
          </template>
        </p>
        <p v-if="personalizationData.phone">
          技术支持：{{ personalizationData.phone }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BottomThe",
  props: {
    personalizationData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    };
  },
  computed: {
    hasValidFooterInfo() {
      const { icpRecord, publicSecurity } = this.personalizationData;
      // 检查是否为空字符串或undefined/null
      const isValidIcp = icpRecord && icpRecord.trim() !== '';
      const isValidPublic = publicSecurity && publicSecurity.trim() !== '';
      return isValidIcp || isValidPublic;
    }
  },
};
</script>

<style scoped lang="scss">
//.bottom {
//  background-color: #333;
//  color: #888888;
//  width: 100%;
//  padding: 40px 0;
//  margin-top: 50px;
//
//  .bottom-footer {
//    text-align: center;
//    font-size: 12px;
//    color: #888888;
//    padding-top: 30px;
//    border-top: 1px solid #393842;
//  }
//}

.footer {
  background: #333;
  color: white;
  padding: 40px 0;
  margin-top: 50px;
  flex-shrink: 0;


  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .footer-logo p {
    margin: 10px 0 0 0;
    font-size: 14px;
    color: #ccc;
  }

  .qr-code {
    width: 100px;
    height: 100px;
  }

  .footer-info {
    text-align: center;
  }

  .footer-info p {
    margin: 5px 0;
    font-size: 14px;
    color: #ccc;
  }

}
</style>
